import { ApplicationConfig, inject, INJECTOR, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';


import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideInscomponents } from '@inscomponents';
import { businessProviders, SuzFactoryService } from '@skylab-angular-shared/business';
import { ApplicationInsightsService, FeatureFlagsService, TelemetryLoggerService } from '@skylab-angular-shared/config';
import { coreProviders, RoutingService, setAppInjector } from '@skylab-angular-shared/core';
import { pipeProviders } from '@skylab-angular-shared/pipes';
import { FormSaveCommandHandler } from '@skylab-angular-shared/scenes';
import { provideGlobalTooltip, provideIconElements, providePressEventPlugin, ThemeSwitcherService } from '@skylab-angular-shared/ui';
import { L10n } from '@skylab-shared/core';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        ...coreProviders,
        ...businessProviders,
        ...pipeProviders,
        RoutingService,
        FeatureFlagsService,
        ThemeSwitcherService,
        ApplicationInsightsService,
        SuzFactoryService,
        TelemetryLoggerService,
        FormSaveCommandHandler,
        provideInscomponents(),
        provideGlobalTooltip(),
        provideIconElements(),
        providePressEventPlugin(),
        provideAppInitializer(async () => {
            const appInjector = inject(INJECTOR);
            setAppInjector(appInjector);
            L10n.setLanguageFiles(['l10n']);
            await L10n.setLangAsync('pl');
        }),
        provideRouter(appRoutes, withComponentInputBinding()),
        provideZoneChangeDetection(),
    ]
};
